import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Button,
  Chip,
  CircularProgress,
} from '@mui/material';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import CheckIcon from '@mui/icons-material/Check';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import GlobalDatagrid from '../../../../components/mui/DataGrid/GlobalDatagrid';
import { useNavigate } from 'react-router-dom';
import ToolTip from '../../../../components/ToolTip/ToolTip';
import TestDetailView from './TestDetailView';
export default function ResponseTable({ title, CRO, setOpen, rows, loading, meta }) {
  const navigate = useNavigate();
  const dataGridHead = [
    { field: 'sl_no', headerName: 'Sl.No', width: 100 },
    { field: 'trainer_name', headerName: 'Name of the tutor', width: 200 },
    { field: 'trainer_mobile', headerName: 'Tutor Contact No.', width: 180 },
    { field: 'trainer_email', headerName: 'Email', width: 250 },
    {
      field: 'student_name',
      headerName: 'Student name',
      width: 180,
      renderCell: ({ value }) => <ToolTip content={value} expand={value} />,
    },
    { field: 'admn_no', headerName: 'Adm.No.', width: 120 },
    { field: 'class_name', headerName: 'Class', width: 120 },
    { field: 'subject_name', headerName: 'Subject', width: 200 },
    {
      field: 'course_name',
      headerName: 'Course',
      width: 200,
      renderCell: ({ value }) => {
        return <ToolTip expand={value} content={value} />;
      },
    },
    {
      field: 'sessionCount',
      headerName: 'Session count',
      width: 150,
      valueGetter: ({ row }) => `${row?.completed_sessions}/${row?.total_sessions}`,
    },
    { field: 'pre_assessment', headerName: 'Pre Assessment', width: 230 },
    { field: 'exam1', headerName: 'E1', width: 230 },
    { field: 'exam2', headerName: 'E2', width: 230 },
    { field: 'exam3', headerName: 'E3', width: 230 },
    { field: 'exam4', headerName: 'E4', width: 230 },
    { field: 'exam5', headerName: 'E5', width: 230 },
    { field: 'exam6', headerName: 'E6', width: 230 },
    { field: 'exam7', headerName: 'E7', width: 230 },
    { field: 'exam8', headerName: 'E8', width: 230 },
    { field: 'post_assessment', headerName: 'Post Assessment', width: 230 },
    {
      field: 'testDetailView',
      headerName: 'Test Detail View',
      width: 170,
      renderCell: ({ row }) => <TestDetailView row={row} />,
    },

    {
      field: 'impactReport',
      headerName: 'Impact Report',
      width: 160,
      renderCell: ({ value, row }) => (
        <Button
          startIcon={<RemoveRedEyeIcon />}
          onClick={() => navigate(`/dashboard/impact-report/${row?.course_enrollment_id}`)}
          // disabled={!Boolean(row?.post_assessment)}
        >
          View
        </Button>
      ),
    },
    {
      field: 'report_downloaded_count',
      headerName: 'Impact Report Status',
      width: 200,
      renderCell: ({ value, row }) =>
        row?.post_assessment ? (
          value ? (
            <Chip
              label={
                <Box display="flex" gap={1} sx={{ alignItems: 'center' }}>
                  <Typography>Downloaded</Typography>
                  <CheckIcon color="success" sx={{ fontSize: 30 }} />
                </Box>
              }
            />
          ) : (
            <Chip
              label={
                <Box display="flex" gap={0.5} sx={{ alignItems: 'center' }}>
                  <Typography>Pending</Typography>
                  <PendingActionsIcon color="warning" sx={{ fontSize: 25 }} />
                </Box>
              }
            />
          )
        ) : (
          <Chip
            label={
              <Box display="flex" gap={0.5} sx={{ alignItems: 'center' }}>
                <Typography>Not Ready</Typography>
              </Box>
            }
          />
        ),
    },
    {
      field: 'courseCompletion',
      headerName: 'Course Completion Certificate',
      width: 260,
      renderCell: ({ row }) => (
        <Button startIcon={<RemoveRedEyeIcon />} onClick={() => setOpen(row?.student_name)}>
          View
        </Button>
      ),
    },
  ];

  const tableHead = [
    'Month',
    'Total Responses Came',
    'Pre assessment',
    'Post Assessment',
    'Exam 1',
    'Exam 2',
    'Exam 3',
    'Exam 4',
    'Exam 5',
    'Exam 6',
    'Exam 7',
    'Exam 8',
    'Total Exam',
  ];
  return (
    <Box>
      {!CRO ? (
        <>
          <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 500, color: 'gray' }}>
            Counts of responses per month
          </Typography>
          <TableContainer
            component={Paper}
            sx={{
              borderRadius: 3,
              boxShadow: 'none',
              overflow: 'auto',
            }}
          >
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: '#f3f5ff' }}>
                  {tableHead.map((e, i) => (
                    <TableCell key={i} sx={{ fontWeight: 600 }}>
                      {e}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell align="center" colSpan={CRO ? 25 : 13}>
                      <Box sx={{ py: 3 }}>
                        <CircularProgress size={28} />
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : (
                  (rows ?? []).map((row, index) => (
                    <TableRow key={index}>
                      <TableCell sx={{ fontWeight: 600 }}>{row?.month}</TableCell>
                      <TableCell>{row?.total_response}</TableCell>
                      <TableCell>{row?.pre_assessment_count}</TableCell>
                      <TableCell>{row?.post_assessment_count}</TableCell>
                      <TableCell>{row?.exam1_count}</TableCell>
                      <TableCell>{row?.exam2_count}</TableCell>
                      <TableCell>{row?.exam3_count}</TableCell>
                      <TableCell>{row?.exam4_count}</TableCell>
                      <TableCell>{row?.exam5_count}</TableCell>
                      <TableCell>{row?.exam6_count}</TableCell>
                      <TableCell>{row?.exam7_count}</TableCell>
                      <TableCell>{row?.exam8_count}</TableCell>
                      <TableCell>{row?.total_exam_count}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      ) : (
        <GlobalDatagrid
          tableHead={dataGridHead}
          rows={rows ?? []}
          rowUniqueId={'sl_no'}
          loading={loading}
          meta={meta?.totalRecords}
        />
      )}
    </Box>
  );
}
